import { render, staticRenderFns } from "./modify_order.vue?vue&type=template&id=4d5b5f67&scoped=true"
import script from "./modify_order.vue?vue&type=script&lang=js"
export * from "./modify_order.vue?vue&type=script&lang=js"
import style0 from "./modify_order.vue?vue&type=style&index=0&id=4d5b5f67&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b5f67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d5b5f67')) {
      api.createRecord('4d5b5f67', component.options)
    } else {
      api.reload('4d5b5f67', component.options)
    }
    module.hot.accept("./modify_order.vue?vue&type=template&id=4d5b5f67&scoped=true", function () {
      api.rerender('4d5b5f67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/modify_order.vue"
export default component.exports